import * as React from "react";
var Unauthorized = function Unauthorized() {
  return /*#__PURE__*/React.createElement("svg", {
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "\u7F16\u7EC4 11"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-21.2%",
    y: "-28.9%",
    width: "148.1%",
    height: "165.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-unauthorized"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.835294118 0 0 0 0 0.882352941 0 0 0 0 0.988235294 0 0 0 1 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.813 17.416h95.388c2.96 0 5.359 2.4 5.359 5.36V89.86a5.356 5.356 0 01-5.359 5.357l-95.388-.03a5.364 5.364 0 01-5.358-5.36V22.775c0-2.96 2.399-5.359 5.358-5.359z",
    id: "path-unauthorized"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .585h160v160H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 30.585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.24 9.545h95.387c2.96 0 5.359 2.4 5.359 5.36v73.684H16.88V14.904c0-2.96 2.4-5.359 5.36-5.359z",
    fill: "#E9EEF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 88.488h139.866c0 6.474-5.248 11.723-11.722 11.723H11.722C5.248 100.21 0 94.962 0 88.488z",
    fill: "#E9EEF7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-unauthorized)",
    xlinkHref: "#path-unauthorized"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#path-unauthorized"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDD5E2",
    cx: 105.754,
    cy: 26.376,
    r: 2.261
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDD5E2",
    cx: 122.634,
    cy: 26.376,
    r: 2.261
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDD5E2",
    cx: 114.194,
    cy: 26.376,
    r: 2.261
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.268 34.833)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#E9EEF7",
    strokeWidth: 2.679,
    cx: 22.266,
    cy: 22.346,
    r: 20.725
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.23 22.582c-3.484 0-6.308-2.806-6.308-6.267 0-3.461 2.824-6.267 6.308-6.267 3.483 0 6.307 2.806 6.307 6.267 0 3.46-2.824 6.267-6.307 6.267zm0 12.533c-5.574 0-10.092-1.383-10.092-4.904 0-3.522 4.518-6.376 10.092-6.376 5.573 0 10.092 2.854 10.092 6.376 0 3.521-4.519 4.904-10.092 4.904z",
    fill: "#CDD5E2",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.22 4.307a2.131 2.131 0 00-1.414-.521h-.15c-.031 0-.36.03-.873.03a18.895 18.895 0 01-4.123-.434C28.62 2.92 26.243.752 25.55.318A2.257 2.257 0 0024.404 0a2.345 2.345 0 00-1.142.318c-.09.06-2.556 2.515-4.961 3.064a19.32 19.32 0 01-4.15.433c-.542 0-.872-.03-.903-.03h-.12a2.072 2.072 0 00-1.414.522c-.418.35-.658.855-.66 1.387v4.797c0 17.691 12.48 19.974 12.99 20.06.24.04.484.04.723 0 .54-.087 13.08-2.37 13.08-20.06V5.694a1.903 1.903 0 00-.63-1.387h.004z",
    fill: "#B6C2D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.738 11.897h-.722v-1.443a3.608 3.608 0 00-3.606-3.607 3.608 3.608 0 00-3.607 3.607v1.443h-.72c-.798 0-1.443.645-1.443 1.442v7.213c0 .797.645 1.443 1.442 1.443h8.656c.797 0 1.442-.646 1.442-1.443v-7.213c0-.797-.645-1.442-1.442-1.442zm-4.328 6.491a1.442 1.442 0 110-2.884 1.442 1.442 0 010 2.884zm2.236-6.491h-4.472v-1.443a2.238 2.238 0 012.236-2.236 2.238 2.238 0 012.236 2.236v1.443z",
    fill: "#FFF",
    fillRule: "nonzero"
  })))));
};
export default Unauthorized;